export default __webpack_public_path__ + "static/media/personality-share-yellow.4aafa2e5.svg";